import { Reducer } from 'redux';
import { RegActionTypes, RegState } from './types';

const initialState: RegState = {
  init: false,
  submitting: false
};
const reducer: Reducer<RegState> = (state = initialState, action: any) => {
  switch (action.type) {
    case RegActionTypes.FETCH_REG_INIT: {
      return {
        ...state,
        init: true
      };
    }
    case RegActionTypes.FETCH_REG_REQUEST: {
      const cleanState: RegState = { init: false, submitting: true };
      return {
        ...cleanState
      };
    }
    case RegActionTypes.FETCH_REG_SUCCESS: {
      const cleanState: RegState = { submitting: false };
      return {
        ...cleanState,
        data: action.payload,
        userName: action.payload.user.username
      };
    }
    case RegActionTypes.FETCH_REG_ERROR: {
      const cleanState: RegState = { submitting: false };
      return {
        ...cleanState,
        errors: action.payload
      };
    }

    case RegActionTypes.FETCH_REG_CONFIRMATION_REQUEST: {
      return {
        ...state,
        submitting: true
      };
    }
    case RegActionTypes.FETCH_REG_CONFIRMATION_SUCCESS: {
      return {
        ...state,
        submitting: false,
        data: action.payload
      };
    }
    case RegActionTypes.FETCH_REG_CONFIRMATION_ERROR: {
      return {
        ...state,
        submitting: false,
        errors: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as RegReducer };
